import axios, { AxiosPromise } from 'axios';

import { IAddress, ICity } from '~/models/Common';
import { mockStates } from '~/utils/mocks/statesMock';

const baseUrl = 'https://servicodados.ibge.gov.br/api/v1';

const LocationService = {
  getStates() {
    return mockStates;
  },

  getCities(uf: string): AxiosPromise<ICity[]> {
    return axios.get(
      `${baseUrl}/localidades/estados/${uf}/municipios?orderBy=nome`,
    );
  },

  getAddressByZipcode(zipcode: string): AxiosPromise<IAddress> {
    return axios.get(`https://viacep.com.br/ws/${zipcode}/json/`);
  },
};

export default LocationService;
